/* 曹仁（字子孝） */
import { defineHero, U, P, D } from '../define.ts';

export default defineHero({
  id: 'caoren', name: '曹仁', sub: '字子孝', faction: 'wei', role: '坦克', weapon: 'axe',
  look: { shield: true, bulk: 1.15, fx: '#9fc2ff', c: { metal: '#6c768d' } },
  skills: [
    ['催眠術', 'trap', '讓目標沉睡 {3/4/5/6} 秒，受到攻擊才會醒來。', { x: { k: 'nuke', sleep: [3, 4, 5, 6] }, aim: U(480), mp: [100, 110, 120, 150], el: 'shadow' }],
    ['食腐群', 'fire', '放出蝙蝠群穿過前方，造成 {125/175/225/300} 傷害。', { x: { k: 'line', dmg: [125, 175, 225, 300], rad: 60, speed: 700 }, aim: D(520, 60), el: 'shadow' }],
    ['吸血結界', 'passive', '附近友軍的普攻吸血 {10/15/20/25}%。', { pv: { aura: { r: 400, ls: [10, 15, 20, 25] } } }],
    ['渾沌之雨', 'thunder', '煉獄巨石接連砸向指定區域，每顆造成 {100/150/200} 傷害並暈眩 1 秒，可傷害建築。', { x: { k: 'meteor', n: 12, gap: 0.35, area: 300, r: 110, dmg: [100, 150, 200], cc: { stun: 1 }, fx: 'fire', bld: true }, aim: P(560, 300) }],
  ],
});
